module.exports = __webpack_public_path__ + "static/media/28.171a0081.png";